var Fluxxor = require('fluxxor');

var constants = require("../constants");
var storeConfig = require('./storeConfig.json');
var dataOfDiff = require('./dataOfDiff.json');

var MainStore = Fluxxor.createStore({

    initialize : function() {
        
        this.data                   = {},
        this.detailData             = {},
        this.updatesData            = {},
        this.aquisitions            = {},
        this.activeTheme            = null,
        this.errors                 = {"popup": false, "error": false, "message": "", "isLoading": false, "data": {}},
        this.errors1                = {"popup": false, "error": false, "message": "", "isLoading": false, "data": {}},
        this.pushDiffData           = {"popup": false, "data": [], "packageHash": ""},
        this.pullDiffData           = {"popup": false, "data": []},
        this.pushConfirmPopup       = {"popup": false, "data": [], "packageHash": ""},
        this.pullConfirmPopup       = {"popup": false, "data": []},
        this.pullVersionPopup       = {"popup": false, "data": null},
        this.rejectPopup            = {"popup": false, "data": null},
        this.rejectOffensivePopup   = {"popup": false, "data": null},
        this.snapshotVersionPopup   = {"popup": false, "data": null},
        this.snapshotErrorPopup     = {"popup": false, "data": null},
        this.activateUser           = {"popup": false, "data": null},
        this.cloneWarningPopup      = {"popup": false, "slug": null},
        this.revokePopup            = {"popup": false, "revokeId": null},
        this.signUpPopup            = {"popup": false, "data": null, "action": {}, "slug": null},
        this.clonePackagePopup      = {"popup": false, "accountSlug": null, "slug": null},
        this.cloneSuccessPopup      = {"popup": false, "newSlug": "", "accountSlug": ""},
        this.sharePackagePopup      = {"popup": false, "data": []},
        this.conflictErrorPopup     = {"popup": false},
        this.provideEmailPopup      = {"popup": false},
        this.verifyEmailPopup       = {"popup": false},
        this.cloneVersionPopup      = false,
        this.errorStack             = storeConfig.errorStack,
        this.signInError            = storeConfig.errorStack.signInError,
        this.signUpError            = storeConfig.errorStack.signUpError,
        this.forgotUsernameError    = storeConfig.errorStack.forgotUsernameError,
        this.activeUserError        = storeConfig.errorStack.activeUserError,
        this.forgotPasswordPopup    = {"popup": false},
        this.signInData             = {},
        this.accountsList           = {},
        this.transferPackagePopup   = {"popup": false, "data": ""},
        this.transferRUSurePopup    = {"popup": false, "data": ""},
        this.transferSuccessPopup   = {"popup": false, "data": ""},
        this.transferRevokePopup    = {"popup": false, "data": ""},
        this.transferWarningDependenciesPopup = {"popup": false, "data": ""},
        this.updatePackagePopup     = {"popup": false, "data": []},

        this.bindActions(
             constants.INIT_DATA,              this.onInitData,
             constants.DETAIL_DATA,            this.onDetailData,
             constants.DEPENDENCY_DATA,        this.onDependencyData,
             constants.LICENSE_DATA,           this.onLicenseData,
             constants.ACTIVE_THEME,           this.onActiveTheme,
             constants.PULL_DATA,              this.onPullData,
             constants.PUSH_DATA,              this.onPushData,
             constants.CLONE_DATA,             this.onCloneData,
             constants.ERROR_MESSAGE,          this.onErrorMessage,
             constants.ERROR_MESSAGE1,         this.onErrorMessage1,
             constants.RESETPOPUP,             this.onResetpopup,
             constants.UPDATES_DATA,           this.onUpdatesData,
             constants.INSTALL_DATA,           this.onInstallData,
             constants.PUSH_DIFF,              this.onPushDiff,
             constants.PULL_DIFF,              this.onPullDiff,
             constants.CONFIRM_PUSH,           this.onConfirmPush,
             constants.CONFIRM_PULL,           this.onConfirmPull,
             constants.PULL_BY_VERSION,        this.onPullByVersion,
             constants.CLONE_BY_VERSION,       this.onCloneByVersion,
             constants.SHARE_PACKAGE_POPUP,    this.onSharePackage,
             constants.REVOKE,                 this.onRevokePopup,
             constants.REJECT_POPUP,           this.onRejectPopup,
             constants.REJECT_OFFENSIVE_POPUP, this.onRejectOffensivePopup,
             constants.SNAPSHOT_VERSION_POPUP, this.onSnapshotVersionPopup,
             constants.SIGNUP_POPUP,           this.onSignUpPopup,
             constants.ACTIVATEUSER_POPUP,     this.onActivateUser,
             constants.CONFLICT_ERROR_POPUP,   this.onConflictError,
             constants.CLONE_SUCCESS_POPUP,    this.onCloneSuccess,
             constants.CLONE_WARNING_POPUP,    this.onCloneWarning,
             constants.SNAPSHOT_ERROR,         this.onSnapshotError,
             constants.VERIFY_EMAIL_POPUP,     this.onVerifyEmail,
             constants.PROVIDE_EMAIL_POPUP,    this.onProvideEmail,
             constants.LIST_OF_ACCOUNTS,       this.onListOfAccounts,
             
             constants.TRANSFER_PACKAGE_POPUP, this.onTransferPackage,
             constants.TRANSFER_R_U_SURE_POPUP,this.onTransferRUSure,
             constants.TRANSFER_SUCCESS_POPUP, this.onTransferSuccess,
             constants.TRANSFER_REVOKE_POPUP,  this.onTransferRevoke,
             constants.TRANSFER_WARNING_DEPENDENCIES_POPUP, this.onTransferWarningDependencies,
             constants.UPDATE_PACKAGE_POPUP,   this.onUpdatePackage,

             constants.SIGNIN_DATA,            this.onSignIn,
             constants.SIGNIN_ERROR,           this.onSignInError,
             constants.SIGNUP_DATA,            this.onSignUp,
             constants.SIGNUP_ERROR,           this.onSignUpError,
             constants.FORGOT_ERROR,           this.onForgotUsername,
             constants.CLEAR_LOGIN_ERRORS,     this.onClearLoginErrors,
             constants.ACTIVEUSER_ERROR,       this.onActiveUserError,
             constants.FORGOT_PASSWORD_POPUP,  this.onForgotPassword
        );
    },

    onInitData: function(payload){
        this.data   = payload.data;
        this.errors = {"popup": false, "error": false, "message": ""};
        this.emit("change");
    },

    onDetailData : function (payload) {
        this.detailData = payload.data
        // this.errors = {"popup": false, "error": false, "message": ""};
        this.emit("change");
    },

    onDependencyData : function (payload) {
        this.dependency =  payload;
        this.errors     = {"popup": false, "error": false, "message": ""};
        this.emit("change");
    },

    onLicenseData : function (payload){
        this.licenses   = payload;
        this.errors     = {"popup": false, "error": false, "message": ""};
        this.emit("change");
    },

    onActiveTheme :  function (payload) {
         this.activeTheme   =  payload.data;
         this.errors        = {"popup": false, "error": false, "message": ""};
         this.emit("change");
    },

    onPullData : function(payload){
        this.errors = {"popup" : true, "error": false, "message": storeConfig.pull.successmsg };
        this.emit("change");
    },

    onPushData : function (payload) {
        this.errors = {"popup" : true, "error": false, "message": storeConfig.push.successmsg };
        this.emit("change");
    },

    onCloneData : function(payload){
        this.clonePackagePopup = {"popup": payload.popup, "accountSlug": payload.accountSlug, "slug": payload.slug };
        // this.errors = {"popup" : true, "error": false, "message": storeConfig.clone.successmsg };
        this.emit("change");
    },


    onInstallData: function(payload){
        this.errors = {"popup" : true, "error": false, "message": payload.message };
        this.emit("change");
    },

    onErrorMessage: function (payload) {
        this.errors = payload;
        this.emit("change");
    },

    onErrorMessage1: function (payload) {
        this.errors1 = payload;
        this.emit("change");
    },

    onResetpopup : function (payload){
        this.errors  = {"popup": false, "error": false, "message": ""};
        this.errors1 = {"popup": false, "error": false, "message": ""};
        this.emit("change");
    },

    onUpdatesData : function (payload){
        this.updatesData = $.extend(this.updatesData, payload.data);  //merge two objects
        this.aquisitions = storeConfig[this.updatesData.type]  //merge two objects
        this.emit("change");
    },

    onPushDiff: function (payload) {
        this.pushDiffData = { "popup": payload.popup, "data": payload.data, "packageHash": payload.packageHash };
        this.emit("change");
    },

    onPullDiff: function (payload) {
        this.pullDiffData = {"popup": payload.popup, "data" : payload.data };
        this.emit("change");
    },

    onVerifyEmail: function(payload) {
        this.verifyEmailPopup = {"popup": payload.popup};
        this.emit("change");
    },

    onConfirmPush: function(payload){
        this.pushConfirmPopup.popup         = payload.popup;
        this.pushConfirmPopup.data          = payload.data;
        this.pushConfirmPopup.packageHash   = payload.packageHash;
        this.emit("change");
    },

    onConfirmPull: function(payload){
        this.pullConfirmPopup.popup = payload.popup;
        this.pullConfirmPopup.data  = payload.data;
        this.emit("change");
    },

    onPullByVersion: function(payload){
        this.pullVersionPopup.popup = payload.popup;
        this.pullVersionPopup.data  = payload.data;
        this.emit("change");
    },

    onCloneByVersion: function(payload){
        this.cloneVersionPopup = payload.popup;
        this.emit("change");
    },

    onSharePackage: function(payload){
        this.sharePackagePopup = {"popup": payload.popup, "data": payload.data};
        this.emit("change");
    },

    onRevokePopup: function(payload){
        this.revokePopup.popup      = payload.popup;
        this.revokePopup.revokeId   = payload.revokeId;
        this.emit("change");
    },

    onRejectPopup: function(payload){
        this.rejectPopup.popup  = payload.popup;
        this.rejectPopup.data   = payload.data;
        this.emit("change")
    },

    onRejectOffensivePopup: function(payload){
        this.rejectOffensivePopup.popup = payload.popup;
        this.rejectOffensivePopup.data  = payload.data;
        this.emit("change");
    },

    onSnapshotVersionPopup: function(payload){
        this.snapshotVersionPopup = {"popup": payload.popup, "data": payload.data};
        this.emit("change")
    },

    onSnapshotError: function(payload){
        this.snapshotErrorPopup = {"popup": payload.popup};
        this.emit("change");
    },

    onSignUpPopup: function(payload) {
        this.signUpPopup = {
            "popup"  : payload.popup,
            "data"   : payload.data,
            "action" : payload.action,
            "slug"   : payload.slug
        };
        this.emit("change");
    },

    onActivateUser: function(payload){
        this.activateUser.popup = payload.popup;
        this.activateUser.data  = payload.data;
        this.emit("change");
    },

    onConflictError: function(payload){
        this.conflictErrorPopup.popup = payload.popup;
        this.emit("change");
    },


    onSignIn: function(payload){
        this.signInData = payload.data;
        this.emit("change");
    },

    onSignInError: function(payload){
        this.signInError = payload.error;
        this.emit("change");
    },

    onSignUp: function(payload){
        this.signUpError = payload.error;
        this.emit("change");
    },

    onSignUpError: function(payload){
        this.signUpError = payload.error;
        this.emit("change");
    },

    onForgotUsername: function(payload){
        this.forgotUsernameError = payload.error;
        this.emit("change");
    },

    onClearLoginErrors: function(){
        this.signInError            = storeConfig.errorStack.signInError;
        this.signUpError            = storeConfig.errorStack.signUpError;
        this.forgotUsernameError    = storeConfig.errorStack.forgotUsernameError;
        this.activeUserError        = storeConfig.errorStack.activeUserError;
        this.emit("change");
    },

    onActiveUserError: function(payload){
        this.activeUserError = payload.error;
        this.emit("change");
    },

    onCloneSuccess: function(payload){
        this.cloneSuccessPopup = { "popup": payload.popup, "accountSlug": payload.accountSlug, "newSlug": payload.newSlug}
        this.emit("change");
    },

    onCloneWarning: function(payload){
        this.cloneWarningPopup  = {"popup": payload.popup, "slug": payload.slug}
        this.emit("change");
    },

    onForgotPassword: function(payload){
        this.forgotPasswordPopup.popup = payload.popup;
        this.emit("change");
    },

    onProvideEmail: function (payload) {
        this.provideEmailPopup = {"popup": payload.popup};
        this.emit("change");
    },

    onListOfAccounts: function(payload) {
        this.accountsList = payload.data;
        this.emit("change");
    },

    onTransferPackage : function(payload){
        this.transferPackagePopup = {"popup": payload.popup};
        this.emit("change");
    },

    onTransferRUSure: function(payload) {
        this.transferRUSurePopup = {"popup": payload.popup, "data": payload.data};
        this.emit("change");
    },

    onTransferSuccess: function(payload) {
        this.transferSuccessPopup = {"popup": payload.popup, "data": payload.data};
        this.emit("change");
    },

    onTransferRevoke: function(payload) {
        this.transferRevokePopup = {"popup": payload.popup};
        this.emit("change");
    },

    onTransferWarningDependencies: function(payload){
        this.transferWarningDependenciesPopup = {"popup": payload.popup, "data": payload.data};
        this.emit("change");
    },

    onUpdatePackage: function(payload){
        this.updatePackagePopup = {"popup": payload.popup, "data": payload.data};
        this.emit("change");
    }
 });


module.exports = {MainStore};



/** WEBPACK FOOTER **
 ** ./html/stores/MainStore.js
 **/